import { observable, action } from 'mobx';
import fetchDataHelper from '../helpers/fetchDataHelper';
import toastNotificationHelper from '../helpers/toastNotificationHelper';

export interface ITitle {
	message: string;
	validUntil: number;
}

export interface INotificationStore {
	soundMuted: boolean;
	soundNeedFirstInteraction: boolean;
	soundMutedToastId: string | number;
	dismissSoundMutedToast(): void;
	title: ITitle;
	browserNotification: string;
	playSound(index: number): void;
	setTitleNotification(message: string): void;
	clearTitle(): void;
	setBrowserNotification(message: string): void;
	setPosts(posts: any[]): void;
}

class NotificationStore implements INotificationStore {

	@observable soundMuted = true;
	@observable soundNeedFirstInteraction = true;
	@observable soundMutedToastId = 0;
	@observable title: ITitle;
	@observable posts: string[];
	@observable browserNotification: string = undefined;
	browserNotificationTimestamps: number[] = [];

	@action.bound dismissSoundMutedToast(): void {
		if (this.soundMutedToastId != 0)
		{
			toastNotificationHelper.dismiss(this.soundMutedToastId);
			this.soundMutedToastId = 0;
		}
	}

	@action.bound playSound(index: number): void {
		if (this.soundMuted) return;

		var url = './src/assets/audio/' + index + '.mp3';
		var audio = new Audio(url);
		audio.play();
	}

	@action.bound setTitleNotification(message: string): void {
		this.title = {
			message: message ? message : 'MoonFinex Scanner',
			validUntil: ((new Date()).getTime() + (30 * 1000))
		};

		document.title = this.title.message;
	}

	@action.bound clearTitle(): void {
		document.title = 'MoonFinex Scanner';
		this.title = undefined;
	}

	@action setBrowserNotification(message: string): void {

		const multipleChangesMessage = 'Multiple changes';
		var actualTime = (new Date()).getTime();

		var shouldNotify = true;		
		if (this.browserNotificationTimestamps.length > 2 && this.browserNotificationTimestamps[this.browserNotificationTimestamps.length-3] > (actualTime - 60000))
			shouldNotify = false; // should not notify if last 3 notifications were in last 1 minute

		this.browserNotificationTimestamps.push(actualTime);

		if (shouldNotify)
			this.browserNotification = message;
		else if (this.browserNotification != multipleChangesMessage )
			this.browserNotification = multipleChangesMessage; // show generic message after 3 notifications 
	}

	@action.bound setPosts(posts: any[]): void {
		this.posts = posts;
		
					
		this.posts.forEach(p => {		
			var message = p;			
			toastNotificationHelper.notifyInfo(message, 60);
		});
	}
}

export default new NotificationStore();